import React from "react";

export function TextField({ label, placeholder, testId, value, onChange, type = "text" }) {
  return (
    <label className="block">
      <div className="text-navy-soft text-xs font-jakarta font-bold uppercase tracking-wider mb-1">
        {label}
      </div>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testId}
        className="w-full bg-bone/70 border border-navy/10 rounded-xl px-3 py-2.5 text-base font-jakarta font-medium text-navy placeholder:text-navy-soft outline-none focus:border-orange/40"
      />
    </label>
  );
}

export function SelectField({ label, testId, value, options, onChange, hint }) {
  return (
    <label className="block">
      <div className="text-navy-soft text-xs font-jakarta font-bold uppercase tracking-wider mb-1">
        {label}
      </div>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
        className="w-full bg-bone/70 border border-navy/10 rounded-xl px-3 py-2.5 text-base font-jakarta font-semibold text-navy outline-none focus:border-orange/40"
      >
        {options.map((o) => (
          <option key={o.id} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
      {hint && (
        <div className="text-navy-soft text-[11px] font-jakarta font-medium mt-1">
          {hint}
        </div>
      )}
    </label>
  );
}
